import React, { useRef, useEffect } from 'react'
import { Dialog, DialogContent, DialogContentText, DialogTitle, Grid, Button, Link, Typography } from '@mui/material';
import colors from '../../../../colors';
import { texts } from '../../../../general/texts';
import ButtonGroup from '../../../../general/ButtonGroup';
import Chart from 'chart.js/auto';


export const ChartModal = (props) => {
    const isOpen = props.isChartModalOpen
    const data = props.data
    const fromDate = props.fromDate
    const toDate = props.toDate
    const pieChartRef = useRef(null);
    const barChartRef = useRef(null);
    const searchMethods = [
        { display: "Pie-Chart", value: '1' },
        { display: "Bar-Chart", value: '2' }
    ]
    const [state, setState] = React.useState({
        selectedSearchMethod: searchMethods[0].value,
        value: '',
    })

    const productSumMap = new Map();

    // krijojm nje array te ri, qe nuk ka producName te perseritura, cdo produkt shfaqe 1 here me vleren totale
    data.transactions.forEach(transaction => {
        const productName = transaction.productName;
        const value = transaction.value;
        if (productSumMap.has(productName)) {
            productSumMap.set(productName, productSumMap.get(productName) + value);
        } else {
            productSumMap.set(productName, value);
        }
    });
    const aggregatedTransactions = Array.from(productSumMap.entries()).map(([productName, value]) => ({
        productName,
        value
    }));

    useEffect(() => {
        const labels = aggregatedTransactions.map(transaction => transaction.productName);
        const data = aggregatedTransactions.map(transaction => transaction.value);
    
        if (pieChartRef.current) {
          Chart.getChart(pieChartRef.current)?.destroy();
        }
        if (barChartRef.current) {
          Chart.getChart(barChartRef.current)?.destroy();
        }
        const renderPieChart = () => {
            const pieChartContext = pieChartRef.current.getContext('2d');
            new Chart(pieChartContext, {
                type: 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                        label: texts["currency"],
                        data: data,
                    }],
                },
            });
        };

        const renderBarChart = () => {
            const barChartContext = barChartRef.current.getContext('2d');
            new Chart(barChartContext, {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [{
                        label: texts["currency"],
                        data: data,
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                            'rgba(255, 205, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(201, 203, 207, 0.2)'
                        ],
                        borderColor: [
                            'rgb(255, 99, 132)',
                            'rgb(255, 159, 64)',
                            'rgb(255, 205, 86)',
                            'rgb(75, 192, 192)',
                            'rgb(54, 162, 235)',
                            'rgb(153, 102, 255)',
                            'rgb(201, 203, 207)'
                        ],
                        borderWidth: 1,
                    }],
                },
            });
        };

        if (state.selectedSearchMethod === '1' && pieChartRef.current) {
            renderPieChart();
        } else if (state.selectedSearchMethod === '2' && barChartRef.current) {
            renderBarChart();
        }
    }, [state.selectedSearchMethod, aggregatedTransactions]);


    const getSearchMethodValue = (value) => {
        setState({ ...state, selectedSearchMethod: value })
    }


    const selectedButtonStyle =
    {
        backgroundColor: colors.lightOrange,
        color: colors.orange,
        width: '150px',
        height: '40px',
        fontFamily: 'GerberaBold',
        textTransform: 'none',
        fontSize: '1rem',
        border: '2px solid' + colors.orange,
        borderRadius: '10px',
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)': { width: '130px', height: '40px' }
    }

    const defaultButtonStyle =
    {
        backgroundColor: colors.lightBlue,
        width: '150px',
        height: '40px',
        borderRadius: '10px',
        textTransform: 'none',
        fontFamily: 'GerberaLight',
        fontSize: '1rem',
        color: colors.darkBlue,
        '&:hover': {
            backgroundColor: colors.lightOrange
        },
        '@media (max-width: 899px)': { width: '130px', height: '40px' }
    }


    return (
        <>
            <Grid>
                <Dialog
                    open={isOpen}
                    onClose={props.handleClose}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    PaperProps={{
                        style: {
                            borderRadius: '20px',
                            padding: '25px'
                        },
                    }}
                >
                    <DialogTitle id="scroll-dialog-title" sx={{ textAlign: 'center', color: colors.darkBlue, fontSize: '1.1rem', fontFamily: 'GerberaBold', marginTop: 2 }} >{texts["title-transaction-graph"]}</DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="scroll-dialog-description"
                            pt={'4%'}
                            sx={{ fontSize: '0.8rem', color: colors.darkBlue, textAlign: 'center', fontFamily: "GerberaLight" }}
                        >
                            <Grid container item md={12} xs={12} justifyContent='center' columnSpacing={5} rowSpacing={3} marginBottom={3}>
                                <ButtonGroup defaultButtonStyle={defaultButtonStyle} selectedButtonStyle={selectedButtonStyle} state={searchMethods} sendValue={getSearchMethodValue} />
                            </Grid>
                            {state.selectedSearchMethod === '1' &&
                                <canvas ref={pieChartRef} width="400" height="400"></canvas>
                            }
                            {state.selectedSearchMethod === '2' &&
                                <canvas ref={barChartRef} width="400" height="400"></canvas>
                            }
                             <Typography fontSize='1rem'   color={colors.darkBlue} marginTop={4}>{fromDate} - {toDate}</Typography>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
            </Grid>
        </>)
}
export default ChartModal